var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('image-input',{ref:"editor",attrs:{"options":_vm.options,"propValue":_vm.propValue,"propReadonly":_vm.readonly,"validateArg":_vm.validateArg,"dataId":_vm.dataId},on:{"editing":_vm.editingHandle}})}
var staticRenderFns = []

export { render, staticRenderFns }